import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { CheckboxlistComponent } from "./checkboxlist/checkboxlist.component";
import { RadiobuttonlistComponent } from "./radiobutton/radiobutton.component";
import { SwitchComponent } from "./switch/switch.component";
import { FileComponent } from "./fileupload/basic-file-upload.component";
import { CarouselModule } from "primeng/carousel";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { CardComponent } from "./card/card.component";
import { OverflowMenuComponent } from "./overflow-menu/overflow-menu.component";
import { hideDropdownButtonDirective } from "./overflow-menu/hideDropdownMenu.directive";
import { DropdownTreeviewComponent } from "./dropdown-treeview/dropdown-treeview.component";
import { NavPillsComponent } from "./nav-pills/nav-pills.component";
import { PanelComponent } from "./panel/panel.component";
import { PrimitiveMultiselectComponent } from "./primitive-multiselect/primitive-multiselect.component";
import { PrimitveDropdownComponent } from "./primitveDropdownlist/primitivedropdown.component";
import { PushmenuComponent } from "./pushmenu/pushmenu.component";
import { SectionComponent } from "./section/section.component";
import { MenuComponent } from "./menu/menu.component";
import { WizardComponent } from "./wizard/wizard.component";
import { ButtonModule } from "primeng/button";
import { SidebarModule } from "primeng/sidebar";
import { TabViewModule } from "primeng/tabview";
import { DropdownButtonComponent } from "./dropdown-button/dropdown-button.component";
import { HttpImgSrcPipe } from "./pipes/http-img-src.pipe";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { AutoCompleteValidatorDirective } from "./directives/autocomplete-validator.directive";
import { ClickElseWhereDirective } from "./directives/click-elsewhere.directive";
import { ClickOutSideDirective } from "./directives/click-out-side.directive";
import { DropdownValidatorDirective } from "./directives/dropdown-validator.directive";
import { ListboxValidatorDirective } from "./directives/listbox-validator.directive";
import { AutofocusDirective } from "./directives/autofocus.directive";
import { GooglePlacesAutocompleteComponent } from "./googleplacesautocomplete/google-places-autocomplete.component";

@NgModule({
  declarations: [
    BreadcrumbComponent,
    CheckboxlistComponent,
    RadiobuttonlistComponent,
    SwitchComponent,
    FileComponent,
    PanelComponent,
    SectionComponent,
    ClickOutSideDirective,
    CardComponent,
    DropdownButtonComponent,
    NavPillsComponent,
    DropdownTreeviewComponent,
    PrimitveDropdownComponent,
    PrimitiveMultiselectComponent,
    hideDropdownButtonDirective,
    PushmenuComponent,
    MenuComponent,
    WizardComponent,
    OverflowMenuComponent,
    HttpImgSrcPipe,
    SafeHtmlPipe,
    DropdownValidatorDirective,
    ClickElseWhereDirective,
    AutoCompleteValidatorDirective,
    ListboxValidatorDirective,
    AutofocusDirective,
    GooglePlacesAutocompleteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TooltipModule,
    CarouselModule,
    OverlayPanelModule,
    DropdownModule,
    TreeModule,
    MultiSelectModule,
    DialogModule,
    SidebarModule,
    ButtonModule,
    TabViewModule,
  ],
  exports: [
    CheckboxlistComponent,
    RadiobuttonlistComponent,
    SwitchComponent,
    FileComponent,
    SectionComponent,
    PanelComponent,
    ClickOutSideDirective,
    CardComponent,
    DropdownButtonComponent,
    NavPillsComponent,
    DropdownTreeviewComponent,
    PrimitveDropdownComponent,
    PrimitiveMultiselectComponent,
    PushmenuComponent,
    BreadcrumbComponent,
    MenuComponent,
    WizardComponent,
    OverflowMenuComponent,
    HttpImgSrcPipe,
    SafeHtmlPipe,
    DropdownValidatorDirective,
    ClickElseWhereDirective,
    AutoCompleteValidatorDirective,
    ListboxValidatorDirective,
    AutofocusDirective,
    GooglePlacesAutocompleteComponent
  ],
  providers: [],
})
export class AdsComponentsModule { }
